export const transparent = 'transparent';
export const black = '#000';
export const hoverBackground = 'rgba(48, 48, 48, 0.8)';
export const brightBlack = '#43494F';
export const blackText = '#2c2c2c';
export const white = '#fff';
export const lightGray = '#f4f3ef';
export const grey = '#ccc';
export const red = '#ff0000';
